import type { Cart } from '@/modules/cart/domain/Cart';
import type { CartRepository } from '@/modules/cart/domain/CartRepository';

const removeOutOfStockItems = (repository: CartRepository): Promise<Cart> => {
  return repository.removeOutOfStockItems();
};

export default removeOutOfStockItems;
